<template>
  <div class="imei-modal-toolbar d-flex flex-wrap align-items-center">
    <button
      v-if="!hideTemplate"
      type="button"
      class="btn btn-light btn-sm imei-modal-toolbar__btn"
      @click="$emit('template')"
    >
      <i class="far fa-file-alt"></i>
      Mẫu Excel
    </button>
    <button
      v-if="!hideImport"
      type="button"
      class="btn btn-light btn-sm imei-modal-toolbar__btn"
      @click="$emit('import')"
    >
      <i class="fas fa-upload"></i>
      Nhập Excel
    </button>
    <button
      type="button"
      class="btn btn-success btn-sm imei-modal-toolbar__btn"
      :disabled="exportDisabled"
      @click="$emit('export')"
    >
      <i class="fas fa-download"></i>
      Xuất Excel
    </button>
  </div>
</template>

<script>
  export default {
    name: 'ImeiInputModalToolbar',
    props: {
      exportDisabled: {
        type: Boolean,
        default: false,
      },
      hideTemplate: {
        type: Boolean,
        default: false,
      },
      hideImport: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<style scoped>
  .imei-modal-toolbar {
    gap: 8px;
  }
  .imei-modal-toolbar__btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
    font-weight: 600;
  }
</style>
